import React from 'react';
import {OrbitComponent} from '../../../../base-components/orbit-component/orbit-component';
import {ArenaHeaderButtonBox} from "../../boxes/arena-header-button/arena-header-button.box";
import {ACTIVE} from "../../css-classes";
import classNames from 'classnames';
import {ArenaHeaderButtonIconBox} from "../../boxes/arena-header-button-icon/arena-header-button-icon.box";
import {ArenaHeaderButtonBackgroundBox} from "../../boxes/arena-header-button-background/arena-header-button-background.box";
import {UriPath} from "../../../../../services/location/uri-path/uri-path";
import {ArenasHeaderButtonConfig} from "../../../../../services/configurations/config-data-sections/mini-orbit.configuration";
import {ArenaHeaderButtonLabelBox} from "../../boxes/arena-header-button-label/arena-header-button-label.box";
import {observer} from 'mobx-react';
import { CyClass } from '../../../../../../common/cy-classes';

export interface ArenasHeaderButtonComponentProps {
    config: ArenasHeaderButtonConfig
}

export const ArenasHeaderButtonComponent = observer(
    class ArenasHeaderButtonComponent extends OrbitComponent<ArenasHeaderButtonComponentProps> {
        private _handleNavigationButtonClick = (config: ArenasHeaderButtonConfig) => {
            this.services.location.push(config.link);
        };

        private _isActive():boolean {
            return this.services.location.currentUri.pathName.equals(new UriPath(this.props.config.link));
        }

        render() {
            if(!this.props.config.link){
                return null;
            }

            const cssClasses=classNames(CyClass('cy-arenas-header-button'), {
                [ACTIVE]: this._isActive()
            });
            
            let arenaTitle = this.services.translation.translate(this.props.config.title);
            return (
                <ArenaHeaderButtonBox className={cssClasses} onClick={() => this._handleNavigationButtonClick(this.props.config)}>
                    <ArenaHeaderButtonBackgroundBox>
                        <ArenaHeaderButtonIconBox src={this.props.config.icon}/>
                    </ArenaHeaderButtonBackgroundBox>
                    <ArenaHeaderButtonLabelBox>
                      {arenaTitle.toUpperCase()}
                    </ArenaHeaderButtonLabelBox>
                </ArenaHeaderButtonBox>);
        }
    }
);